<script setup lang="ts">
import { DropdownMenuSeparator as Sep } from 'reka-ui';
</script>

<template>
  <Sep class="-mx-1 my-1 h-px bg-border" />
</template>
